import NotificationViewState from '../store/schema/NotificationViewState';
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';

export default action('removeNotification')(function removeNotification(
    notification: NotificationViewState
) {
    let index = store.notificationViewStates.indexOf(notification);

    if (index >= 0) {
        store.notificationViewStates.splice(index, 1);
    }
});
